
import { Injectable, Inject } from '@angular/core';
import { GeneralHandler } from './general.handler';
import { DVMService } from '../services/dvm.service';
import { DVM_CONFIG } from "../configuration/dvm-configuration";
import { DVMConfiguration } from "../configuration/dvm-configuration.model";
import { Popover3dviewService } from '../services/popover-3dview.service';

@Injectable()
export class PopoverDestroyHandler extends GeneralHandler {
    constructor(protected dvmService: DVMService,
                private popover3dview: Popover3dviewService,
                @Inject(DVM_CONFIG) private dvmConfig: DVMConfiguration) {
        super('leave', dvmService);
    }

    protected handle(obj) {
        const tooltip: HTMLElement = document.querySelector('#tooltip');
        this.popover3dview.setTimer();
    }
}
